import { Box, IconButton, LinearProgress, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChecklistProgressBar = styled(LinearProgress)(({ theme }) => ({
    flex: 1,
    height: theme.spacing(1),
    backgroundColor: theme.palette.cement[100],
    '& .MuiLinearProgress-bar': {
        backgroundColor: theme.palette.brandPurple.main,
    },
}));

export const ChecklistRow = styled(Stack)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.cement[100]}`,
    },
}));

export const ChevronToggle = styled(IconButton)(({ theme }) => ({
    color: theme.palette.cement[400],
}));

export const StepIndicator = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'completed',
})<{ completed: boolean }>(({ theme, completed }) => ({
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(5),
    height: theme.spacing(5),
    borderRadius: '50%',
    color: completed ? theme.palette.common.white : theme.palette.text.primary,
    backgroundColor: completed ? theme.palette.success.main : theme.palette.cement[100],
}));

export const SubstepIndicator = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'completed',
})<{ completed: boolean }>(({ theme, completed }) => ({
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: '50%',
    color: theme.palette.common.white,
    ...(completed
        ? { backgroundColor: theme.palette.success.main }
        : { border: `2px dashed ${theme.palette.cement[400]}` }),
}));
